/*
 * @Author: hongye yanghongye@jtexpress.com
 * @Date: 2025-12-02 19:21:45
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-12 14:17:50
 * @Description: file content
 */
import { createApp } from 'vue'
import App from '@/App.vue'
import registerPlugin from '@/plugins/index'
import store from '@/store/store'
import router from './router'
import registerCompoent from '@/components/index'
import './assets/style/common.less'
import 'virtual:svg-icons-register'
import registerGlobalProperties from '@/plugins/globalProperties'
console.log('VITE_APP_ENV', 1111)
const app = createApp(App)
const packageList = [store, router, registerCompoent]
packageList.forEach((p) => app.use(p))
//按需注册全局组件
registerPlugin(app)
registerGlobalProperties(app)
app.mount('#app')
